import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const token = localStorage.getItem("token") || null;
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
  headers: {
    Authorization: `Bearer ${token}`,
    "Access-Control-Allow-Origin": "*",
  },
});

// // custom hook fires onClick
// const useFetchData = () => {
//   const [data, setData] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [apiError, setApiError] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");

//   const fetchData = useCallback(async (url, payload) => {
//     setIsLoading(true);
//     try {
//       const response = await api.post(url, payload);
//       setData(response);
//       setApiError(false);
//     } catch (error) {
//       console.error(error);
//       setApiError(true);
//       setErrorMessage(error);
//     } finally {
//       setIsLoading(false);
//     }
//   }, []);
//   return {
//     data,
//     isLoading,
//     apiError,
//     errorMessage,
//     setErrorMessage,
//     setApiError,
//     fetchData,
//   };
// };

// // custom hook fires onClick
// const useFetchData = () => {
//   const [data, setData] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [apiError, setApiError] = useState(null);

//   const fetchData = useCallback(async (apiCall) => {
//     setIsLoading(true);
//     setApiError(false);
//     try {
//       const response = await apiCall();
//       setData(response);
//     } catch (error) {
//       console.error(error.message);
//       setApiError(error);
//     } finally {
//       setIsLoading(false);
//     }
//   }, []);
//   return { data, isLoading, apiError, fetchData };
// };

// custom hook fires upon arrival
const useFetchData = (apiCall, id, payload) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await apiCall(id, payload);
        setData(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);
  return { data, isLoading, error };
};

export default useFetchData;
